<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="320"
      v-if="showdialogflag === true"
    >
      <template> </template>
      <v-card>
        <v-card-title class="text-h5" style="word-break: break-word"
          >{{ dialogTitle }}
        </v-card-title>
        <v-card-text :style="textStyling">{{ dialogText }}</v-card-text>
        <v-card-actions v-if="closeDialog">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog">
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    showdialogflag: Boolean,
    closeDialog: Function,
    dialogTitle: String,
    dialogText: String,
    // The default is an empty string, ensuring that the default of v-card-text is used
    textStyling: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
};
</script>
